import { render, staticRenderFns } from "./select-lender.vue?vue&type=template&id=55bb59b6"
import script from "./select-lender.vue?vue&type=script&lang=ts"
export * from "./select-lender.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports